//#region src/region-grammar.ts
/**
* The one lowercase cloud region grammar of the contracts, in a module with no imports.
*
* Why a module of its own (2026-10-13-blob-buckets, WS-1): `app-pool.ts` binds the fixture blob
* binding of `blob-buckets.ts` in its pool twin, and `blob-buckets.ts` names this grammar as its
* bucket location grammar. Both reads run when each module loads. With the declaration in
* `app-pool.ts`, the two modules import each other, and the module that loads second reads an
* uninitialised binding. Here the declaration has no dependency, so both modules import it and
* neither imports the other for it. `app-pool.ts` re-exports it under the same name, so every
* existing import of `APP_POOL_REGION_PATTERN` from `app-pool.js` and from the barrel still holds.
*/
/**
* The grammar of a pool's `region` (2026-09-29-gpu-and-regional-app-pools D-13, DF-1): a cloud region
* name such as `us-east4` or `europe-west1`. A lowercase letter, then 1 to 30 lowercase letters,
* digits or hyphens, so 2 to 31 characters in all. The pattern is anchored and has one bounded
* repetition, so a match runs in time linear in the input.
*
* Readers: the optional `region` member of both pool arms, its JSON Schema twin in
* `app-manifest.schema.json` (pinned byte-equal by `app-pool-region.test.ts`), the satellite
* admin route's `:region` parameter in `dp-satellites.ts`, the `region` of a rate-card row in
* `billing.ts` (2026-10-02-regional-pools-release-2 D-13, DF-1), and `BLOB_BUCKET_LOCATION_PATTERN`
* in `blob-buckets.ts`. The grammar says nothing about whether the region exists or is enabled: the
* operator resolves a regional pool against the data plane's enabled satellites and reports
* `region-not-enabled` when it finds none (DF-3).
*/
const APP_POOL_REGION_PATTERN = /^[a-z][a-z0-9-]{1,30}$/;
//#endregion
export { APP_POOL_REGION_PATTERN };

//# sourceMappingURL=region-grammar.js.map